import { Card, Heading, Image } from "@chakra-ui/react";
import { ReactElement } from "react";

import { RoundedButton } from "@/components/rounded-button";

export const OnboardingCard = ({
  iconSrc,
  title,
  description,
  renderImage,
  slotBottom,
  ctaText = "Continue",
  ctaFunction,
  topLabel,
}: {
  iconSrc?: string;
  title: string;
  description: string | ReactElement;
  slotBottom?: ReactElement;
  ctaText?: string;
  ctaFunction: () => void;
  renderImage?: () => ReactElement;
  topLabel?: string;
}) => {
  return (
    <Card.Root
      maxW={600}
      gap={6}
      px={[6, 6, 12]}
      py={[8, 8, 12]}
      borderRadius="3xl"
      overflow="hidden"
    >
      <Card.Body gap={6} p={0}>
        {iconSrc && <Image boxSize={16} src={iconSrc} alignSelf="center" />}
        {topLabel && (
          <Heading
            fontSize={["2xl"]}
            color="text.secondary"
            textAlign="center"
            fontWeight="700"
            lineHeight="32px"
            letterSpacing="-0.47px"
            mb={-2}
          >
            {topLabel}
          </Heading>
        )}
        <Card.Title
          fontFamily="heading"
          fontWeight="bold"
          fontSize={["3xl", "3xl", "4xl"]}
          textAlign="center"
        >
          {title}
        </Card.Title>
        {typeof description === "string" ? (
          <Card.Description
            fontFamily="heading"
            fontWeight="medium"
            fontSize={["lg", "lg", "xl"]}
            textAlign="center"
            alignSelf="center"
          >
            {description}
          </Card.Description>
        ) : (
          description
        )}
        {renderImage && renderImage()}
      </Card.Body>
      <Card.Footer flexDirection="column" gap={8} p={0}>
        <RoundedButton onClick={ctaFunction} w="full" size="2xl">
          {ctaText}
        </RoundedButton>
        {slotBottom}
      </Card.Footer>
    </Card.Root>
  );
};
